import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import { Modal } from 'react-bootstrap';
import FeatherIcon from 'feather-icons-react';

interface FilterModalProps {
  show: boolean;
  handleClose: () => void;
  desc?: string;
  title?: string;
  duration?: number;
  handleSubmit: () => void;
  loading: boolean;
}

const QuizStartAssessmentModal = ({
  show,
  handleClose,
  desc,
  title,
  duration,
  handleSubmit,
  loading
}: FilterModalProps) => {
  return (
    <Modal show={show} onHide={handleClose} className="p-0" centered size="lg">
      <Modal.Header className="border-translucent px-4 py-2">
        <h5 className="modal-title text-body-highlight fs-6 lh-sm">
          Core Basics
        </h5>
        <Button className="p-1 ms-auto" onClick={handleClose}>
          <FontAwesomeIcon icon={faTimes} size="2x" />
        </Button>
      </Modal.Header>
      <Modal.Body className="pt-4 pb-2 px-4">
        <h5>{title}</h5>
        <p>{desc}</p>
        <div className="mt-3">
          <h6>Fair assessment policy</h6>
          <p>
            To ensure fairness, we track browser activity and submission
            patterns to detect any signs of cheating during the test attempt.
          </p>
          <p>During the test attempt, DO NOT:</p>
          <ul>
            <li>Open new browser tabs or windows</li>
            <li>Capture screenshots</li>
            <li>Conduct any online searches for answers</li>
            <li>
              Utilize any tools to answer questions (such as ChatGPT, browser
              plugins, etc.)
            </li>
          </ul>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-end align-items-center px-4 pb-4 border-0 pt-3">
        <div className="d-flex align-items-center h-100">
          <FeatherIcon icon="clock" className="me-2" width={16} height={16} />
          <p className="mb-0 fs-9 fw-semibold text-body-tertiary">
            {duration} Mins left
          </p>
        </div>
        <Button
          variant="primary"
          size="sm"
          className="px-9 fs-9 my-0"
          onClick={handleSubmit}
          loading={loading}
          loadingPosition="start"
          disabled={loading}
        >
          Start
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default QuizStartAssessmentModal;
